export const action = (state = { atWork: false, onInterruption: false, working: false, lastActivity: null }, action) => {
  switch (action.type) {
    case "ACTIVITY_ARRIVAL": {
      return { ...state, atWork: true, working: false, onInterruption: false, lastActivity: action.payload.lastActivity }
    }    
    case "ACTIVITY_DEPARTURE": {
      return { ...state, atWork: false, working: false, onInterruption: false, lastActivity: action.payload.lastActivity }
    }
    case "ACTIVITY_INTERRUPTION": {
      return { ...state, onInterruption: true, atWork: true, working: false, lastActivity: action.payload.lastActivity }
    }
    case "ACTIVITY_INTERRUPTION_END": {
      return { ...state, onInterruption: false, atWork: true, working: false, lastActivity: action.payload.lastActivity }
    }
    case "ACTIVITY_WORK": {
      return { ...state, working: true, atWork: true, onInterruption: false, lastActivity: action.payload.lastActivity }
    }
    case "ACTIVITY_WORK_END": {
      return { ...state, working: false, atWork: true, onInterruption: false, lastActivity: action.payload.lastActivity }
    }
    case "ACTIVITY_PAUSE": {
      return { ...state, working: false, atWork: true, onInterruption: false, lastActivity: action.payload.lastActivity }
    }
    case "ACTIVITY_CONTINUE": {
      return { ...state, working: true, atWork: true, onInterruption: false, lastActivity: action.payload.lastActivity }
    }
    default: {
      return state
    }
  }
}
